export const versionInfo = {
  gitTag: 'v-1.2.1-99-gb1d1846',
  tag: 'v-1.2.1',
  commitsAhead: '99',
  buildDate: 'Wed, 02 Sep 2026 11:45:24 GMT'
};
